import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import BirthDateInput from './../../components/BirthDateInput/BirthDateInput';
import * as actionTypes from './../../store/actions/birthDateAction';
import fetchBirthDateAction from './../../store/actions/fetch/fetchBirthDateAction';
import Loader from './../../components/Loader/Loader';

/**
 * Birth Date container
 */
class BirthDate extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const { data, error, pending, selected, onSelect, onSetYear, onSetMonth,
      defaultValues, ready, readyBreed, selectedDataBreed, setLifeStage, visible,
      toggleVisibility, hideSelector, showSelector, onDateChange, years, months } = this.props;

    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready || !readyBreed) return (
      <Loader/>
    );
    // Return switcher

    return (
      <div className='nppe2-fc-birth-date-input__wrapper'>
        {error && <span className='nppe2-fc-birth-date-input__error'>{error}</span>}
        {!error && <BirthDateInput
          data={data}
          selected={selected}
          selectedYears={years}
          selectedMonths={months}
          onSelect={onSelect}
          onSetYear={onSetYear}
          onSetMonth={onSetMonth}
          visible={visible}
          toggleVisibility={toggleVisibility}
          hideSelector={hideSelector}
          showSelector={showSelector}
          onDateChange={onDateChange}
        /> }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.birthDateReducer.selected,
    years: state.birthDateReducer.years,
    months: state.birthDateReducer.months,
    error: state.birthDateReducer.error,
    data: state.birthDateReducer.data,
    pending: state.birthDateReducer.pending,
    ready: state.birthDateReducer.ready,
    readyBreed: state.breedReducer.ready,
    selectedDataBreed: state.breedReducer.selectedData,
    visible: state.birthDateReducer.visible,
    date: state.birthDateReducer.date,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchBirthDateAction
      },
      dispatch,
    ),
    onSelect: (id) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
    }),
    onSetYear: (selectedYears) => dispatch({
      type: actionTypes.SET_YEAR,
      years: selectedYears,
    }),
    onSetMonth: (selectedMonths) => dispatch({
      type: actionTypes.SET_MONTH,
      months: selectedMonths,
    }),
    onDateChange: (data) => dispatch({
      type: actionTypes.SET_DATE,
      selected: data,
    }),
    toggleVisibility: (isFocussed) => dispatch({
      type: actionTypes.TOGGLE_VISIBILITY,
      isFocussed: isFocussed,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    hideSelector: () =>  dispatch({
      type: actionTypes.HIDE,
    }),
    showSelector: () =>  dispatch({
      type: actionTypes.SHOW,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(BirthDate);
